import { Country } from '@cash-web/protos/squareup/common/countries.pb'
import { DisplayCountry } from '@cash-web/protos/squareup/franklin/scenarios.pb'

type CountryInfoMap = {
  [key in Country]: DisplayCountry
}

export function countryInfoMap(displayCountries?: DisplayCountry[]): CountryInfoMap | undefined {
  const countryMap = displayCountries?.reduce((countryInfoSoFar, displayCountry) => {
    const updatedCountryInfo = countryInfoSoFar
    if (displayCountry.country_code) {
      updatedCountryInfo[displayCountry.country_code] = displayCountry
    }
    return updatedCountryInfo
  }, {} as CountryInfoMap)

  return countryMap
}
